import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-button-cancel',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
  template: `
    <button mat-flat-button type="button" [disabled]="disabled" mat-button>
      {{ 'shared.cancel' | translate }}
    </button>
  `,
  styles: [],
})
export class ButtonCancelComponent {
  @Input() disabled: boolean | null = false;
}
